/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { defineMessages } from 'react-intl';

export const describeServiceDesk = defineMessages({
  failed: {
    id: 'channels.describeServiceDeskFailed',
    defaultMessage: 'Cannot access the service desk.'
  }
});

export const connectServiceDesk = defineMessages({
  success: {
    id: 'channels.connectServiceDesk.success',
    defaultMessage: 'Integration was successfully connected.'
  },
  failed: {
    id: 'channels.connectServiceDesk.failed',
    defaultMessage: 'Integrations could not be connected at this time.'
  },
  subscriptionExists: {
    id: 'channels.connectServiceDesk.subscriptionExists',
    defaultMessage: `Cannot create integration. Integration {integration} in assistant {assistant}
      is already subscribed for this application. To connect this integration,
      please disconnect the other one.`
  },
  anotherSubscription: {
    id: 'channels.connectServiceDesk.anotherSubscription',
    defaultMessage:
      'Cannot create integration. Another integration is already subscribed for this application. To connect this integration, please disconnect the other one.'
  }
});

export const disconnectServiceDesk = defineMessages({
  failed: {
    id: 'channels.disconnectServiceDesk.failed',
    defaultMessage: 'Integration could not be disconnected at this time.'
  }
});

export const intelepeerCheckFail = defineMessages({
  failed: {
    id: 'channels.intelepeerCheckFail.failed',
    defaultMessage:
      'The IntelePeer number status could not be determined at this time.'
  }
});

export const createIBMPublicKey = defineMessages({
  failed: {
    id: 'channels.createIBMPublicKey.failed',
    defaultMessage: 'Unable to load IBM provided public key.'
  }
});

export const webhookSubscribe = defineMessages({
  failed: {
    id: 'channels.webhookSubscribe.failed',
    defaultMessage: 'Unable to load webhook URL.'
  }
});

export const createPhoneIntegrationFail = defineMessages({
  failed: {
    id: 'channels.createPhoneIntegrationFail.failed',
    defaultMessage: 'The specified phone number is already in use.'
  }
});

export const selectPhoneGatewayIntegrationFail = defineMessages({
  failed: {
    id: 'channels.selectPhoneGatewayIntegrationFail.failed',
    defaultMessage:
      'Phone gateway secret could not be retrieved therefore phone gateway integration cannot be created.'
  }
});
